import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import pageData from "../config/careersPageData.json";
import { FaLinkedin, FaEnvelope, FaUserCircle } from "react-icons/fa";

const ApplyCareer = () => {
  const { id } = useParams();
  const jobDetails = pageData.careersSection.openPositions.find(
    (p) => p.id === id
  );
  const navigate = useNavigate();

  return (
    <div className="max-w-7xl mx-auto px-6 pt-24 mt-12 pb-12">
      {/* Back Button */}
      <button
        onClick={() => navigate(-1)}
        className="mb-6 text-blue-600 hover:underline flex items-center"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-5 h-5 mr-1"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15.75 19.5L8.25 12l7.5-7.5"
          />
        </svg>
        Back to Listings
      </button>

      <div className="flex flex-col lg:flex-row gap-8">
        {/* Main Content */}
        <div className="flex-1">
          <h1 className="text-3xl font-bold text-black mb-2">
            {jobDetails.title}
          </h1>
          <p className="text-black mb-1">
            {jobDetails.location} • {jobDetails.type}
          </p>
          <p className="text-sm text-black mb-4">
            Posted on: {jobDetails.createdDate}
          </p>

          {/* Job Description Section */}
          <section className="mb-4">
            <h2 className="text-2xl font-semibold text-black mb-4">
              Job Description
            </h2>
            <h2 className="text-xl font-semibold text-black">Job Summary:</h2>
            <p className="text-black mt-2">{jobDetails.summary}</p>
          </section>

          {/* Responsibilities */}
          <section className="mb-4">
            <h2 className="text-xl font-semibold text-black">
              Responsibilities:
            </h2>
            <ul className="list-disc list-inside text-black mt-2 space-y-1">
              {jobDetails.responsibilities.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </section>

          {/* Requirements */}
          <section className="mb-4">
            <h2 className="text-xl font-semibold text-black">Requirements:</h2>
            <ul className="list-disc list-inside text-black mt-2 space-y-1">
              {jobDetails.requirements.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </section>

          {jobDetails.preferred && (
            <section className="mb-4">
              <h2 className="text-xl font-semibold text-black">
                Preferred Qualifications:
              </h2>
              <ul className="list-disc list-inside text-black mt-2 space-y-1">
                {jobDetails.preferred.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            </section>
          )}

          {/* About Company */}
          <section>
            <h2 className="text-xl font-semibold text-black">About Company:</h2>
            <p className="text-black mt-2">{jobDetails.aboutCompany}</p>
          </section>
        </div>

        {/* Sidebar */}
        <div className="w-full lg:w-1/3 space-y-6 sticky top-24 h-fit">
          {/* Posted By Card */}
          <div className="bg-white/30 backdrop-blur-md border border-white/10 p-6 rounded-2xl shadow-[0_4px_30px_rgba(0,0,0,0.1)] transition-all duration-300 hover:shadow-xl space-y-3">
            <p className="text-xs text-gray-500 font-semibold">Posted by</p>
            <h2 className="text-lg font-semibold text-black">
              {jobDetails.contact.name}
            </h2>
            <div className="flex items-center gap-2">
              <FaLinkedin className="text-blue-600 text-xl" />
            </div>
            <p className="text-sm text-gray-700">
              {jobDetails.contact.message}
            </p>
            <p className="text-sm text-gray-700">{jobDetails.contact.note}</p>
            <div className="flex items-center gap-2">
              <FaEnvelope className="text-black text-sm" />
              <a
                href="mailto:sandeep.pethala@glowtechsolutions.in"
                className="text-sm text-blue-700 hover:underline"
              >
                sandeep.pethala@glowtechsolutions.in
              </a>
            </div>
            <div className="flex gap-2 pt-2">
              <a
                href="https://linkedin.com/in/sandeeppethala/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="px-4 py-2 bg-white/80 backdrop-blur-md border border-gray-300 text-sm text-gray-800 rounded-lg hover:bg-white">
                  View Profile
                </button>
              </a>
            </div>
          </div>

          {/* Apply Card */}
          <div className="bg-white/30 backdrop-blur-md border border-white/10 p-6 rounded-2xl shadow-[0_4px_30px_rgba(0,0,0,0.1)] transition-all duration-300 hover:shadow-xl space-y-4">
            <p className="text-sm text-indigo-800 font-semibold uppercase tracking-wide">
              {jobDetails.company.greeting}
            </p>
            <p className="text-lg font-semibold text-black">
              {jobDetails.company.name}
            </p>
            <div>
              <a href="mailto:hr@glowtechsolutions.in">
                <button className="bg-white/80 backdrop-blur-md border border-gray-300 px-4 py-2 rounded-lg shadow inline-flex items-center gap-2 text-sm font-medium hover:bg-white">
                  Apply with Resume <FaUserCircle className="text-gray-700" />
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplyCareer;
